export default [
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'notifications',
        name: 'Notifications',
        component: () => import("../form/user/Query.vue"),
        meta: { title: 'U2EDC-Admin', requiresAuth: true },
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'profile',
        name: 'Profile',
        component: () => import("../form/login/UserForm.vue"),
        meta: { title: 'U2EDC-Admin', requiresAuth: true, isAdmin: false, },
    },
    {
        // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
        // ex)  path: 'institution' -> admin/institution
        path: 'passwordChangeReminder',
        name: 'PasswordChangeReminder',
        component: () => import("../form/user/PasswordChangeReminder.vue"),
        meta: { title: 'U2EDC-Admin', requiresAuth: true, isAdmin: false, },
    },
];
